export enum PartsMenuKeysEnum {
  SwapSimilarPart = 'swapSimilarPart',
  ViewProductPage = 'viewProductPage',
  WhereUsed = 'whereUsed',
  CompareProduct = 'compareProduct',
  DeletePart = 'deletePart',
  ReplacePart = 'replacePart',
  ChangeLocation = 'changeLocation',
  LocationItems = 'locationItems',
  ZoomIn = 'zoomIn',
  ZoomOut = 'zoomOut',
}
